import React from "react";
import "./AboutPage.css";

function AboutPage() {
  return (
    <div className="about-page">
      <img
        src="/jobfind24-logo.png"
        alt="JobFind24 Logo"
        className="about-page-logo"
        style={{
          display: 'block',
          margin: '0 auto 24px',
          maxWidth: '320px',
          width: '100%',
          height: 'auto',
        }}
      />
      <div className="about-page-hero">
        {/* <span className="about-page-kicker">About</span> */}
        <h1>About JobFind24.shop</h1>
        <p className="about-page-intro">
          JobFind24.shop is a modern platform where you get the latest and most authentic information about government and private jobs, exams, results, admit cards, syllabus, and selection processes—all in one place. Our mission is to ensure that every student, job seeker, or professional receives the right information at the right time to help them succeed in their career.
        </p>
      </div>
      <div className="about-page-grid">
        <div className="about-page-card">
          <h2>Market</h2>
          <p>
            Today’s job market is highly competitive and opportunities are changing rapidly. Many students and job seekers miss out on the best jobs or exams simply because they don’t get the right information at the right time.
          </p>
          <p>
            JobFind24.shop aims to provide every user with the latest and most authentic updates about government and private sector jobs, exams, results, admit cards, and syllabus—all in one place. We understand the needs of the market and deliver up-to-date, reliable resources for all types of users so you can move forward in your career.
          </p>
        </div>
        <div className="about-page-card">
          <h2>Vision</h2>
          <p>
            To empower every student and job seeker so they can make the right career decisions and never miss out on any job information. We want every youth to have the opportunity to fulfill their dreams without any information gap.
          </p>
        </div>
        <div className="about-page-card">
          <h2>Features</h2>
          <ul>
            <li>Latest government & private job updates</li>
            <li>Admit card, result, syllabus, and selection info</li>
            <li>User-friendly search & navigation</li>
            <li>Contact support for queries</li>
            <li>Dark/Light mode for better experience</li>
            <li>Mobile-friendly responsive design</li>
          </ul>
        </div>
        <div className="about-page-card">
          <h2>Mission</h2>
          <p>
            The right information at the right time, for every youth! At JobFind24.shop, we update new jobs, exams, and results daily so you never miss an important opportunity.
          </p>
        </div>
        <div className="about-page-card">
          <h2>Why Use JobFind24.shop?</h2>
          <ul>
            <li><strong>All-in-one platform:</strong> Get jobs, results, admit cards, and syllabus updates at one place.</li>
            <li><strong>Authentic & Fast Updates:</strong> Only verified and latest information, updated daily.</li>
            <li><strong>Easy to Use:</strong> Simple, clean, and mobile-friendly interface for everyone.</li>
            <li><strong>Time Saver:</strong> No need to visit multiple sites—find everything you need quickly.</li>
            <li><strong>Dark/Light Mode:</strong> Comfortable viewing experience for your eyes.</li>
            <li><strong>Free & Always Available:</strong> No charges, no login required, always accessible.</li>
          </ul>
        </div>
        <div className="about-page-card">
          <h2>Project Owner</h2>
          <p>
            <strong>Dheeraj Kumar</strong><br/>
            Email: <a href="mailto:jobfind24.shop@gmail.com">jobfind24.shop@gmail.com</a>
          </p>
        </div>
        <div className="about-page-card">
          <h2>Contact</h2>
          <p>
            If you have any queries or want to give feedback, you can message us on the Contact Us page. We are always here to help you!
          </p>
          <p>
            Email: <a href="mailto:jobfind24.shop@gmail.com">jobfind24.shop@gmail.com</a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default AboutPage;
